
export enum SoundNotification  {
  Enable ='Enable',
  Disable = 'Disable',
  DisableSim = 'DisableSim',
  Alert = 'Alert'
}